module.exports = {"630102001":"东关大街街道","630102002":"清真巷街道","630102003":"大众街街道","630102004":"周家泉街道","630102005":"火车站街道","630102006":"八一路街道","630102007":"林家崖街道","630102100":"乐家湾镇","630102101":"韵家口镇","630102400":"东川工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630102.json
// module id = 3118
// module chunks = 0